import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { oneRename, oneRemove } from '~data/actions/tags';
import t from '~t';

import { Confirm } from '~co/overlay/dialog';
import Rename from './rename';
import View from './view';
import Contextmenu from './contextmenu';

export default function TagsItem({ item, active = false, ...props }) {
  const dispatch = useDispatch();
  const [rename, setRename] = useState(false);
  const [menu, setMenu] = useState(false);

  const onRenameClick = useCallback(() => setRename(true), []);
  const onRenameCancel = useCallback(() => setRename(false), []);

  const onRename = useCallback(
    (newName, success, fail) =>
      dispatch(oneRename(item._id, newName, success, fail)),
    [dispatch, item._id],
  );

  const onRemoveClick = useCallback(async () => {
    if (await Confirm(t.s('areYouSure'), { variant: 'warning' }))
      dispatch(oneRemove(item._id));
  }, [dispatch, item._id]);

  const onContextMenu = useCallback((e) => {
    e.preventDefault();
    e.target.focus();
    setMenu(true);
  }, []);

  const onContextMenuClose = useCallback(() => setMenu(false), []);

  const onKeyUp = useCallback(
    (e) => {
      switch (e.keyCode) {
        case 46: //delete
        case 8: //backspace
          e.preventDefault();
          return onRemoveClick();

        case 13: //enter
          e.preventDefault();
          return onRenameClick();
      }
    },
    [onRemoveClick, onRenameClick],
  );

  const handlers = {
    onRenameClick,
    onRenameCancel,
    onRename,
    onRemoveClick,
    onContextMenu,
    onContextMenuClose,
    onKeyUp,
  };

  const Component = rename ? Rename : View;

  return (
    <>
      <Component
        {...props}
        item={item}
        active={active}
        {...handlers}
        focusable={true}
      />

      {menu ? (
        <Contextmenu
          {...props}
          item={item}
          active={active}
          {...handlers}
        />
      ) : null}
    </>
  );
}
